import { alpha } from '@mui/material/styles';

export default theme => {
    const purple = theme.palette.secondary.main;

    return {
        // Default: a static "Osano AI" pill with a purple glow, no motion.
        root: {
            position: 'fixed',
            right: theme.spacing(3),
            bottom: theme.spacing(3),
            zIndex: theme.zIndex.speedDial,
            '& .MuiButton-root': {
                minWidth: 0,
                gap: theme.spacing(1),
                padding: theme.spacing(1.125, 2, 1.125, 1.125),
                borderRadius: 30,
                backgroundColor: theme.palette.background.paper,
                border: `1px solid ${alpha(purple, 0.4)}`,
                // Static purple glow. The design prototype pulses this; we don't.
                boxShadow: `0 0 0 3px ${alpha(purple, 0.1)}, 0 0 16px 1px ${alpha(purple, 0.42)}`,
                '&:hover': {
                    backgroundColor: theme.palette.background.paper,
                },
            },
            '& .aiLauncherLabel': {
                fontWeight: 700,
                whiteSpace: 'nowrap',
                lineHeight: 1.2,
            },
        },
        // Opt-in behavior (expandOnHover): collapse to a circle around the mark and
        // slide the label open on hover/focus. Off by default per the design review;
        // kept as a modifier so it can be turned back on without rebuilding it.
        expandable: {
            '& .MuiButton-root': {
                gap: 0,
                padding: theme.spacing(1.125),
                transition: theme.transitions.create('padding', {
                    duration: theme.transitions.duration.shorter,
                }),
                '&:hover': {
                    paddingRight: theme.spacing(2),
                },
            },
            // Label stays present (accessible name) but collapses to zero width so
            // the button reads as a circle until hovered/focused.
            '& .aiLauncherLabel': {
                maxWidth: 0,
                opacity: 0,
                paddingLeft: 0,
                overflow: 'hidden',
                transition: theme.transitions.create(['max-width', 'opacity', 'padding-left'], {
                    duration: theme.transitions.duration.standard,
                }),
            },
            '& .MuiButton-root:hover .aiLauncherLabel, & .MuiButton-root:focus-visible .aiLauncherLabel':
                {
                    maxWidth: 160,
                    opacity: 1,
                    paddingLeft: theme.spacing(1),
                },
        },
    };
};
